import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Return = {
  isGettingOnboardingDetails: boolean;
  onboardUser: (userId: string) => Promise<void>;
};

export const useOnboardUser = (): Return => {
  const { onboardingApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<void, AxiosError, string>({
    meta: { disableErrorAlert: true, disableSuccessAlert: true },
    mutationFn: async userId => {
      await onboardingApi.runOnboardingActions(userId);
    },
    mutationKey: [QueryKeyEnum.USERS.ONBOARDING_RUN],
  });

  return {
    isGettingOnboardingDetails: isPending,
    onboardUser: mutateAsync,
  };
};
